// Default configuration (fallback)
export const defaultConfig = {
    // Tenant bilgileri
    tenantId: "superdernek",
    tenantName: "SuperDernek",

    // Site bilgileri
    siteName: "SuperDernek - Dernekler İçin Dijital Çözümler",
    siteSlogan: "Dernekler İçin Dijital Çözümler",
    siteDescription: "E-imza, KEP ve kurumsal dijital dönüşüm hizmetleri",
    siteUrl: "https://superdernek.com",

    // Logo
    logo: {
        main: "/superdernek_logo.webp",
    },
    widget_video_url: "/assets/videos/animation.mp4",

    // Renkler
    colors: {
        primary: "#1ac8ff",
        secondary: "#fda832",
        accent: "#9c27b0"
    },

    headerColors: {
        primary: "#1976d2",
        linkBackground: "#1976d22e",
        default: "#4b5563",
        textColor: '#374151',
        applyButton: "linear-gradient(to right, #db0934, #940d58)",
        applyButtonHover: "linear-gradient(to right, #c20830, #7a0b4a)",
        dealerButton: "linear-gradient(to right, #FF6F00, #F57C00)",
        dealerButtonHover: "linear-gradient(to right, #E65100, #EF6C00)"
    },

    homePage: {
        hero: {
            primary: '#940d58',
            chipColor: "linear-gradient(to bottom right, #db0934, #940d58)",
            bottomGradient: "linear-gradient(to bottom right, #db0934, #940d58)",
            boxShadow: '0 10px 20px rgba(148, 13, 88, 0.3)',
            bgColor: "rgba(148, 13, 88, 0.3)",
            statsIconBgColor: "rgba(255,255,255,0.1)"
        },
        products: {
            primary: '#940d58',
            chipBackground: '#940d581a',
            cardHoverBorder: '#940d5796',
            buttonColor: '#940d58',
            buttonBorder: '#940d58'
        },
        useCases: {
            primary: '#940d58',
            chipBackground: '#940d581a',
            iconBackground: '#940d581a',
            countChipBackground: '#940d581a',
            countChipColor: '#940d58',
            bgGradient: 'linear-gradient(to bottom right, #db093403, #940d580a)'
        },
        benefits: {
            primary: '#ca0e76',
            chipBackground: '#940d581a',
            cardBorder: '#ca0e76',
            iconColor: '#ca0e76'
        },
        features: {
            primary: '#940d58',
            chipBackground: '#940d581a',
            iconBackground: '#940d5815',
            cardHoverBorder: '#940d58',
            iconColor: '#940d58',
            bgGradient: 'linear-gradient(to bottom right, #db093403, #940d580a)'
        },
        howItWorks: {
            primary: '#940d58',
            chipBackground: '#940d581a',
            connectionLine: 'linear-gradient(90deg, #a7f3d0, #99f6e4, #7ee7ee)',
            ctaText: '#940d58',
            ctaButton: 'linear-gradient(to bottom right, #db0934, #940d58)',
            ctaButtonHover: '#059669'
        },
        integrations: {
            primary: '#940d58',
            chipBackground: '#940d581a',
            cardHoverBorder: '#10b981',
            titleHoverColor: '#10b981'
        },
        workContent: {
            bgGradient: 'linear-gradient(to bottom right, #db093403, #940d580a)',
            chipGradient: 'linear-gradient(to bottom right, #db0934, #940d58)',
            topBorderGradient: 'linear-gradient(to right, #db0934, #940d58)',
            cardHoverBorder: 'rgba(148, 13, 88, 0.2)'
        },
        cta: {
            bgColor: '#a8003a',
            primaryButtonBg: 'white',
            primaryButtonColor: '#a8003a',
            secondaryButtonBorder: 'white',
            secondaryButtonColor: 'white'
        }
    },


    pricingPage: {
        primary: "#940d58",
        primaryPassive: '#d32f2f',
        background: "#940d581a",
        isOutOfStockHover: '#a8003a',
        backgorundGradient: "linear-gradient(to bottom right, #db0934, #940d58)"
    },

    productsPage: {
        primary: "#940d58",
        backgroundGradient: "linear-gradient(to bottom right, #db0934, #940d58)",
        tabBackgroundGradient: "linear-gradient(to right, #db0934, #940d58)",
        hoverBorderColor: "#940d5796"
    },

    applyPage: {
        primary: "#940d58",
    },


    aboutPage: {
        backgorundGradient: "linear-gradient(to bottom right, #db0934, #940d58)",
        border: "1px solid #940d58"
    },

    iletisimPage: {
        primary: "#940d58",
        secondary: "#db0934",
        backgorundGradient: "linear-gradient(135deg, #940d58 0%, #db0934 100%)"
    },
    eImzaBasvuruPage: {
        primary: "#940d58",
        primaryHover: "#a8003a",
        secondaryColor: "#882121",
        chipBackgroundGradient: "linear-gradient(to bottom right, #db0934, #940d58)"
    },
    signInPage: {
        dealerBoxBackground: "rgba(148, 13, 88, 0.06)",
        dealerBoxBorder: "rgba(148, 13, 88, 0.2)",
        dealerBoxHoverBackground: "rgba(148, 13, 88, 0.1)",
        dealerBoxHoverBorder: "rgba(148, 13, 88, 0.4)",
        dealerBoxShadow: "0 4px 12px rgba(148, 13, 88, 0.2)"
    },

    // İletişim bilgileri
    contact: {
        phone: "+90 850 244 45 50",
        email: "iletisim@ucuzimza.com",
        address: "Aydın, Türkiye",
        kep: "ronesansinovasyonvemuhendislik@hs01.kep.tr",
        destekEmail: "destek@ucuzimza.com"
    },

    // Sosyal medya
    social: {
        facebook: "",
        twitter: "",
        instagram: "",
        linkedin: "",
        youtube: ""
    },

    // SEO
    meta: {
        title: "SüperDernek | Resmi Altyapılı Dijital Dernek Yönetim Platformu",
        description: "SüperDernek ile derneğinizi dijitale taşıyın. Üye yönetimi, aidat takibi, bağış sistemi, web sitesi, e-imza, KEP entegrasyonu ve mobil uygulama ile tüm dernek süreçlerini tek platformdan yönetin.",
        keywords: "dernek yönetim sistemi, dernek yazılımı, e-imza dernek sistemi, kep entegrasyonu, aidat takibi, dernek üye yönetimi, dijital dernek yönetimi, dernek otomasyonu",
        ogImage: "/superdernek-og-image.jpg"
    },

    // Özellikler
    features: {
        showBlog: true,
        showDealership: true,
        showPricing: true,
        showOrderTrack: true
    }
};
